import * as yup from 'yup'
import { REQUIRED_FIELD } from 'constants/errors'

export const schemaDetailedChartFilters = yup.object().shape({
  from: yup.string().nullable().required(REQUIRED_FIELD),
  to: yup.string().nullable().required(REQUIRED_FIELD),
})
